import {useSidebar} from '@/contexts/SidebarContext/SidebarContext';
import {SIDEBAR_CATEGORY_LABELS} from '@/contexts/SidebarContext/types';
import {Box, Typography} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import {DesktopNotificationPrompt} from '../DesktopNotificationPrompt';
import {
  SIDEBAR_COLLAPSED_WIDTH,
  SIDEBAR_EXPANDED_WIDTH,
  SUBSIDEBAR_WIDTH,
} from '../sidebarWidths';
import {SubSidebarContent} from './SubSidebarContent';

export const SubSidebar = () => {
  const theme = useTheme();
  const {
    selectedCategory,
    getItemsForCategory,
    isSubSidebarCollapsed,
    isSidebarPinned,
  } = useSidebar();

  const items = selectedCategory ? getItemsForCategory(selectedCategory) : [];

  if (!selectedCategory || items.length === 0) {
    return null;
  }

  const sidebarWidth = isSidebarPinned
    ? SIDEBAR_EXPANDED_WIDTH
    : SIDEBAR_COLLAPSED_WIDTH;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        width: `${SUBSIDEBAR_WIDTH}px`,
        padding: '32px 11px',
        borderRight: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        height: '100vh',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '24px',
        flexShrink: 0,
        position: 'fixed',
        top: 0,
        left: sidebarWidth,
        zIndex: 1100,
        transform: isSubSidebarCollapsed
          ? `translateX(-${SUBSIDEBAR_WIDTH}px)`
          : 'translateX(0)',
        transition:
          'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: 16,
          fontWeight: 600,
          lineHeight: 1,
          letterSpacing: '0.15px',
          color: theme.palette.text.primary,
          px: 1,
        }}
      >
        {SIDEBAR_CATEGORY_LABELS[selectedCategory]}
      </Typography>
      <SubSidebarContent items={items} />
      <Box sx={{mt: 'auto', width: '100%'}}>
        <DesktopNotificationPrompt isPopover={false} />
      </Box>
    </Box>
  );
};
